import type { CSSProperties } from "react";

/**
 * The one selected-state recipe for configurator chips (string counts,
 * scales, presets, gauges, windings, quantity tiers): gold border + subtle
 * gold fill when selected, neutral otherwise.
 */
export function chipStyle(selected: boolean): CSSProperties {
  return {
    borderColor: selected ? "#E8C547" : "#2A2A2A",
    backgroundColor: selected ? "#E8C54715" : "#141414",
    color: selected ? "#E8C547" : "#9A9A9A",
  };
}
